var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2069 1.57162L22.2598 1.62449C22.8414 2.47047 23.1057 3.47506 22.9471 4.42679C22.8414 5.37851 22.3126 6.27736 21.4667 6.91185L5.86897 18.6498L1.7977 18.7027C1.53333 18.7027 1.26897 18.6498 1.0046 18.4912C0.74023 18.3854 0.528736 18.2268 0.370115 17.9624C0.211494 17.7509 0.0528736 17.4866 0 17.2222C0 16.9578 0 16.6935 0.105747 16.3762L1.26897 12.5164L16.8667 0.778513C17.7126 0.14403 18.7172 -0.0674642 19.669 0.0911565C20.6736 0.196904 21.5724 0.725639 22.2069 1.57162ZM17.131 2.94633L19.5103 6.06587L20.3563 5.43139C20.7793 5.11414 21.0437 4.63828 21.0966 4.16242C21.1494 3.68656 21.0437 3.15782 20.7264 2.73483L20.6736 2.68196C20.3563 2.25897 19.9333 1.9946 19.4046 1.94173C18.9287 1.83598 18.4529 1.9946 18.0299 2.25897L17.131 2.94633ZM18.0299 7.17621L15.6506 4.05667L4.07126 12.7808L6.3977 15.9004L18.0299 7.17621ZM4.75862 16.7992L2.74943 14.1027L1.90345 16.8521L4.75862 16.7992Z",
    fill: "#D4D4D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6eb8c683037bccb2a37e36f4ee98b47b.svg";
export { ForwardRef as ReactComponent };